import { gql, useQuery } from '@apollo/client';
import get from 'lodash.get';
import React, { useEffect, useState } from 'react';

import { preOpInstructions, partnerInstructions } from 'kb-shared';
import { InstructionsModal, InstructionRow } from 'screens/MyJourney/details/InstructionsModal';

import instructionRenderer from '../instructionRenderer';

interface ShowProps {
  show: boolean;
  hide: () => void;
}

const PRE_OP_INSTRUCTIONS: InstructionRow[] = preOpInstructions.map(instructionRenderer);

const PARTNER_INSTRUCTIONS: InstructionRow[] = partnerInstructions.map(instructionRenderer);

const CYCLE_PLAN = gql`
  query cyclePlan {
    cyclePlan {
      id
      spermSource
    }
  }
`;

export const PreopInstructionsModal = ({ show, hide }: ShowProps) => {
  const [instructions, setInstructions] = useState(PRE_OP_INSTRUCTIONS);

  const { data, loading, error } = useQuery(CYCLE_PLAN);

  useEffect(() => {
    if (!data) return;
    const spermSource = get(data, ['cyclePlan', 'spermSource']);
    if (spermSource === 'Partner') {
      setInstructions(() => [...PRE_OP_INSTRUCTIONS, ...PARTNER_INSTRUCTIONS]);
    }
  }, [data]);

  if (loading || error || !data) {
    return null;
  }

  return (
    <InstructionsModal
      title="Pre-operative Instructions"
      show={show}
      hide={hide}
      rows={instructions}
    />
  );
};
